// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1bjV5","label":"CategoryService_label__2_QC-","location":"CategoryService_location__3LXCZ"};